let DataLoader = {
  load: function(url, callback) {
    $.ajax({
      url: url,
      method: 'GET',
      dataType: 'json',
      success: callback,
      error: function(reason, xhr) {
        console.log('error in processing your request', reason);
        console.log(xhr);
      },
    });
  },
};

export default DataLoader;
